import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const About = () => {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-center">
          
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="mb-12 lg:mb-0"
          >
            <div className="relative rounded-2xl overflow-hidden shadow-2xl bg-slate-800">
              <img 
                src="https://images.unsplash.com/photo-1504307651254-35680f356f27?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80" 
                alt="Bauprojekt MK Netzbau" 
                loading="lazy"
                onError={(e) => { 
                  e.target.onerror = null; 
                  e.target.src = 'https://placehold.co/800x800/1e293b/f59e0b?text=MK+Netzbau';
                }}
                className="w-full h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 to-transparent flex items-end p-8">
                <div className="text-white">
                  <p className="text-2xl font-bold text-amber-500 mb-2">Qualität & Termintreue</p>
                  <p className="text-sm text-slate-200">Strukturierte Umsetzung im urbanen und ländlichen Raum.</p>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-base text-amber-500 font-semibold tracking-wide uppercase">Unternehmensprofil</h2>
            <h3 className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-slate-900 sm:text-4xl">
              Alles aus einer Hand.
            </h3>
            <div className="mt-6 text-slate-600 space-y-6 text-lg">
              <p>
                Die <strong>Mk Netzbau GmbH</strong> ist ein spezialisierter Ausbaupartner für Glasfaserprojekte in den Netzebenen NE3 und NE4. Wir fokussieren uns auf die ganzheitliche Umsetzung von FTTH-Rollouts, vom Tiefbau über den Hausanschlussbau bis hin zur Inhouse-Glasfaserinstallation.
              </p>
              <p>
                Durch die Bündelung von Tiefbau, Installation und technischer Ausbauleistung innerhalb einer Organisation ermöglichen wir eine durchgängige Projektabwicklung. Zusätzliche Kapazitäten durch Partnerunternehmen erlauben uns eine flexible Skalierung.
              </p>
              <div className="bg-slate-50 p-6 rounded-xl border border-slate-100 shadow-sm mt-8">
                <h4 className="text-xl font-bold text-slate-900 mb-4 flex items-center">
                  <SafeIcon name="Target" className="h-6 w-6 text-amber-500 mr-2" />
                  Unsere Philosophie
                </h4>
                <p className="text-slate-700 italic">
                  "Glasfaserausbau bedeutet für uns: Planung, Bau und Installation aus einer Hand. Durch eigene Kolonnen, Installationsteams und Bauüberwachung schaffen wir kurze Wege, schnelle Abläufe und nachhaltige Ergebnisse."
                </p>
              </div>
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default About;